import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { CONTACT_PATH } from 'routes';
import { openContactUsModal } from 'store/modules/modals';

class ContactUsLink extends Component {
  handleClick = event => {
    if (this.props.isLoggedIn) {
      this.props.openContactUsModal();
      event.preventDefault();
    }
  };

  render() {
    return (
      <Link
        to={CONTACT_PATH}
        onClick={this.handleClick}
        className="navmenu__link">
        Contact us
      </Link>
    );
  }
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isUserLoggedIn,
});

const mapDispatchToProps = {
  openContactUsModal: openContactUsModal,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ContactUsLink),
);



// WEBPACK FOOTER //
// ./src/scenes/Footer/ContactUsLink.js